import { defineMessages } from 'react-intl';

export default defineMessages({
    vehicleX: {
        id: 'ml.quoteandbind.pup.vehicleInfoComponent.VEHICLE x',
        defaultMessage: 'VEHICLE {vehicleIndex}'
    },
    vinNumber: {
        id: 'ml.quoteandbind.pup.vehiclevinlookup.VIN Number',
        defaultMessage: 'VIN'
    },
    vinNumberPlaceholder: {
        id: 'ml.quoteandbind.pup.vehiclevinlookup.Enter VIN',
        defaultMessage: 'Enter VIN'
    },
    vinOrSerialNumber: {
        id: 'ml.quoteandbind.pup.vehiclevinlookup.VIN/Serial Number',
        defaultMessage: 'VIN/Serial Number'
    },
    vinOrSerialNumberPlaceholder: {
        id: 'ml.quoteandbind.pup.vehiclevinlookup.Enter VIN/Serial Number',
        defaultMessage: 'Enter VIN/Serial Number'
    },
    vinInputBottomLabel: {
        id: 'ml.quoteandbind.pup.vehiclevinlookup.VIN required. Must be 17 digits if 1981 and newer.',
        defaultMessage: 'VIN required. Must be 17 digits if 1981 and newer.'
    },
    serialNumberLabel: {
        id: 'ml.quoteandbind.pup.vehicleInfoComponent.Serial Number',
        defaultMessage: 'Serial Number'
    },
    serialNumberPlaceholder: {
        id: 'ml.quoteandbind.pup.vehicleInfoComponent.Enter Serial Number',
        defaultMessage: 'Enter Serial Number'
    }
});
